import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Container, FloatingLabel, Form, Image, Tab, Table, Tabs } from 'react-bootstrap';
import { Button, TextField } from '@mui/material';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { LoginInfo } from '../App';
import { Chip, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import Constants from './common/Constants';
import LoadingButton from '@mui/lab/LoadingButton';

const PointSend = (props) => {
	async function send(userId,point){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point/send",{userId:userId,point:point}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getPoint(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point").then((r)=>{
            return r.json()
        })
    }
	async function suisen(groupId,point){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/suisen/regist",{groupId:groupId,point:point}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getSuisenPoint(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/suisen").then((r)=>{
            return r.json()
        })
    }
    function getCoin(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/balance/").then((r)=>{
            return r.json()
        })
    }
    function postComment(groupId,type,itemId,targetUserId,comment){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/comment/"+groupId,{type:type,itemId:itemId,targetUserId:targetUserId,comment:comment}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const location = useLocation()
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
	const [terms,setTerms] = useState("")
    const [coin, setCoin] = useState(0)
    const [buyAmount,setBuyAmount] = useState(200) // 購入する枠
    const [itemId,setItemId] = useState("b5c0fb1f-0dc0-11ef-9428-0242ac130002") // 購入する枠の商品ID
    const [amountColor,setAmountColor] = useState("#FFFFFF") // 購入する枠の選択色
    const [amountBGColor,setAmountBGColor] = useState("#FFFFFF") // 購入する枠の色
    const [point,setPoint] = useState(0) // 保有ポイント
    const [inputPoint,setInputPoint] = useState(500) // 選択中のポイント

    const [suisenPoint,setSuisenPoint] = useState(0) // 保有推薦ポイント
    const [inputSuisenPoint,setInputSuisenPoint] = useState(500) // 選択中の推薦ポイント
    const [loading,setLoading] = useState(false) // 読み込み中
    const amountBGColorList = {
        "#00E5FF":"#FFFFFF", // 200
        "#1DE9B6":"#F3FEFB", // 500
        "#F7CA50":"#FEFAED", // 1000-1500
        "#E68231":"#FCF2EA", // 2000-2500
        "#D63D65":"#FBEBEF", // 5000-7500
        "#E62117":"#FCE8E7", // 10000-50000
    }
    useEffect(() => {
        setAmountBGColor(amountBGColorList[amountColor])
    },[amountColor])

	useEffect(() => {
        getCoin().then(r => {
            if(r.result){
              setCoin(r.data.balance)
            } else {
              setCoin(0)
            }
          })
		getPoint().then(r=>{
			if(r.result){
				setPoint(r.point)
			}
		})
		getSuisenPoint().then(r=>{
			if(r.result){
				setSuisenPoint(r.point)
			}
		})
	},[location.pathname])

    const rainbowColors = [
        {color: "#00E5FF", amount: 200, itemId: "b5c0fb1f-0dc0-11ef-9428-0242ac130002"},
        {color: "#1DE9B6", amount: 500, itemId: "b884eef4-0dc0-11ef-9428-0242ac130002"},
        {color: "#F7CA50", amount: 1000, itemId: "b884ef42-0dc0-11ef-9428-0242ac130002"},
        {color: "#F7CA50", amount: 1500, itemId: "ba14ca0a-0dc0-11ef-9428-0242ac130002"},
        {color: "#E68231", amount: 2000, itemId: "ba14ca66-0dc0-11ef-9428-0242ac130002"},
        {color: "#E68231", amount: 2500, itemId: "ba14ca6e-0dc0-11ef-9428-0242ac130002"},
        {color: "#D63D65", amount: 5000, itemId: "ba14ca78-0dc0-11ef-9428-0242ac130002"},
        {color: "#D63D65", amount: 7500, itemId: "bbe01da2-0dc0-11ef-9428-0242ac130002"},
        {color: "#E62117", amount: 10000, itemId: "bbe01dd6-0dc0-11ef-9428-0242ac130002"},
        {color: "#E62117", amount: 20000, itemId: "bbe01ddd-0dc0-11ef-9428-0242ac130002"},
        {color: "#E62117", amount: 40000, itemId: "bbe01de2-0dc0-11ef-9428-0242ac130002"},
        {color: "#E62117", amount: 50000, itemId: "bbe01de7-0dc0-11ef-9428-0242ac130002"},
    ]
    const [key,setKey] = useState("point")
    return(
        <Container>
            <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",backgroundColor:"#000000",opacity:0.3,zIndex:4}} onClick={() => props.switch(false)} />
            <div id="point-send-popup-view" className="wrapper p-3" style={{position:"fixed",left:(window.innerWidth-300)/2,width:"300px",zIndex:5,overflow:"auto",backgroundColor:"#FFFFFF",borderRadius:"10px"}}>
            <div className={props.groupId !== undefined && props.id_auth === 1 ? "d-block" : "d-none"}>
                <h5>{props.userName} を応援する</h5>
                <p className='grey'>応援コメント枠を購入する</p>
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                        <InputLabel id="demo-select-small-label">購入額</InputLabel>
                        <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={buyAmount}
                            label="Day"
                            onChange={(e) => {
                                setAmountColor(rainbowColors.find(d => d.amount === e.target.value).color)
                                setBuyAmount(e.target.value)
                                setItemId(rainbowColors.find(d => d.amount === e.target.value).itemId)
                            }}
                        >
                            {[rainbowColors.map((d,i) => {
                                return <MenuItem value={d.amount}><span style={{backgroundColor:d.color,borderRadius:"18px",fontSize:"12px",color:i > 3 ? "#FFFFFF" : "#000000"}} className='p-1'><MonetizationOnIcon style={{fontSize:"14px",color:i > 3 ? "#FFFFFF" : "#000000"}} /> {d.amount.toLocaleString()}</span></MenuItem>
                            })]}
                        </Select>
                    </FormControl>
                    <TextField
                        multiline
                        label="コメント"
                        id="ouen-comment"
                        defaultValue={"応援しています！"}
                        style={{backgroundColor:amountBGColor}}
                        sx={{ m: 1, width: '25ch' }}
                    /><br />
                <p className='grey' style={{fontSize:"14px"}}>保有コイン:{coin.toLocaleString()}<br />コメント欄に公開されます。</p>
                <LoadingButton loading={loading} variant='contained' style={{borderRadius:"18px"}} onClick={() =>{
                    setLoading(true)
                    let comment = document.getElementById("ouen-comment").value
                    postComment(props.groupId,props.type,itemId,props.userId,comment).then(r => {
                        if(r.result){
                            props.switch(false)
                            props.dialog(t("common.info"),<><Icon.CheckCircle style={{color:"green"}} /> 応援コメントを投稿しました。</>)
                        } else {
                            alert(r.errors)
                        }
                        setLoading(false)
                    })
                }}>購入してコメントを送信</LoadingButton>
                <hr />
                <p className='grey' style={{fontSize:"14px"}}>その他の支援方法</p>
            </div>
            <Tabs activeKey={key} onSelect={(key) => setKey(key)}>
                <Tab eventKey={"point"} title="ポイントを贈る"></Tab>
                {props.type === "image" ? <Tab eventKey={"suisen"} title="作品を推薦"></Tab> : ""}
            </Tabs>
            {key === "point" ? (<>
            <Table striped bordered hover style={{width:"100%"}} className='mt-3 simple-table'>
                <thead>
                    <tr><th>保有生成ポイント</th><th>贈るポイント</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{verticalAlign:"middle",textAlign:"center"}}>{point}</td>
                        <td>
                            <Form.Control id='input-point' type="number" defaultValue={inputPoint} min={1} max={10000} step={1} onChange={(e) => {
                                setInputPoint(e.currentTarget.value)
                            }} />
                        </td>
                    </tr>
                </tbody>
            </Table>
            <Button variant='outlined'
            onClick={() => {
                let inputPoint = document.getElementById("input-point").value
                if(inputPoint <= 0){
                    props.dialog(t("common.info"),"1以上を指定してください。")
                    return
                }
                send(props.userId,inputPoint).then(r => {
                    if(r.result){
                        props.switch(false)
                        props.dialog(t("common.info"),<><Icon.CheckCircle style={{color:"green"}} /> {inputPoint}ポイントを「<b>{props.userName}</b>」さんへ贈りました。</>)
                    } else {
                        alert(r.errors)
                    }
                })
            }}
            ><Icon.HeartFill />&nbsp;贈る</Button>
            <Button variant='outline-secondary' style={{marginLeft:"10px"}} onClick={() => props.switch(false)}>{t("common.close")}</Button>
            </>) : ""}

            {key === "suisen" && props.type === "image" ? <>
            <Table striped bordered hover style={{width:"100%"}} className='mt-3 simple-table'>
                <thead>
                    <tr><th>保有推薦ポイント</th><th>使用するポイント</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{verticalAlign:"middle",textAlign:"center"}}>{suisenPoint}</td>
                        <td>
                            <Form.Control id='input-suisen-point' type="number" defaultValue={inputSuisenPoint} min={1} max={1000} step={1} onChange={(e) => {
                                setInputSuisenPoint(e.currentTarget.value)
                            }} />
                        </td>
                    </tr>
                </tbody>
            </Table>
            <Button variant='outlined'
            onClick={() => {
                let inputSuisenPoint = document.getElementById("input-suisen-point").value
                if(inputSuisenPoint <= 0){
                    props.dialog(t("common.info"),"1以上を指定してください。")
                    return
                }
                suisen(props.groupId,inputSuisenPoint).then(r => {
                    if(r.result){
                        props.switch(false)
                        props.dialog(t("common.info"),<><Icon.CheckCircle style={{color:"green"}} /> {inputSuisenPoint}ポイントを使って推薦しました。</>)
                    } else {
                        alert(r.errors)
                    }
                })
            }}
            ><Icon.HeartFill />&nbsp;推薦する</Button>
            <Button variant='outline-secondary' style={{marginLeft:"10px"}} onClick={() => props.switch(false)}>{t("common.close")}</Button>
            </> : ""}
            </div>
    </Container>
    )
}

export default PointSend;
